<div class="dialog-header" [class.shadow]="hasScrolled">
  <h2>{{ isEditMode ? 'Contato' : 'Adicionar contato' }}</h2>
  <button mat-icon-button mat-dialog-close>
    <mat-icon svgIcon="close-current"> </mat-icon>
  </button>
</div>

<mat-dialog-content #dialogScrollArea>
  <form [formGroup]="contactDataForm">
    <!-- dados do contato -->
    <spe-titulo-sessao titulo="Dados do contato" icone="/assets/icones/cinza/usuarios.svg"></spe-titulo-sessao>

    <mat-form-field
      class="mb-8"
      [ngClass]="commonService.switchMatErrorClassResponsivity(contactDataFormControl.nomeContato)"
    >
      <mat-label>Nome completo</mat-label>
      <input matInput type="text" formControlName="nomeContato" />
      <mat-error>{{ validatorErrors(contactDataFormControl.nomeContato) }}</mat-error>
    </mat-form-field>

    <mat-checkbox
      [checked]="contactDataFormControl.flagResponsible.value === 'S'"
      (change)="onFlagResponsibleChange($event)"
    >
      <b>Responsável pela compra dos benefícios</b>
    </mat-checkbox>

    <!-- contato -->
    <spe-titulo-sessao titulo="Contato" icone="/assets/icones/cinza/contato.svg"></spe-titulo-sessao>

    <!-- telefones -->
    <div *ngFor="let telefone of additionalPhonesControls; let i = index" [formGroup]="telefone">
      <mat-form-field>
        <mat-label>Tipo</mat-label>
        <mat-select formControlName="tipoContato">
          <mat-option *ngFor="let tipo of tiposDeContato" [value]="tipo.id">
            {{ tipo.descricao }}
          </mat-option>
        </mat-select>
        <mat-icon matSuffix class="color-brand-principal">keyboard_arrow_down</mat-icon>
      </mat-form-field>

      <div class="d-flex align-items-start">
        <mat-form-field>
          <mat-label>Telefone com DDD</mat-label>
          <input
            matInput
            type="text"
            formControlName="phoneNumber"
            [mask]="getPhoneMask(telefone.get('tipoContato')?.value)"
          />
          <button *ngIf="i != 0" mat-icon-button matSuffix (click)="removerTelefone(i)">
            <mat-icon svgIcon="lixo-current" class="color-brand-principal"></mat-icon>
          </button>
          <mat-error *ngIf="telefone.get('phoneNumber')?.invalid">Telefone inválido.</mat-error>
        </mat-form-field>

        <mat-form-field *ngIf="telefone.get('tipoContato')?.value === 1" class="w-25 ms-2">
          <mat-label>Ramal</mat-label>
          <input matInput type="text" formControlName="ramal" />
          <mat-error>&nbsp;</mat-error>
        </mat-form-field>
      </div>
    </div>

    <a href="#" class="add-new" (click)="adicionarOutroTelefone(); $event.preventDefault()">Adicionar outro telefone</a>

    <!-- emails -->
    <div *ngFor="let email of secundaryEmailsControls; let i = index" [formGroup]="email">
      <mat-form-field>
        <mat-label>{{ i === 0 ? 'Email principal' : 'Email adicional' }}</mat-label>
        <input matInput type="email" formControlName="email" placeholder="exemplo@dominio.com" />

        <mat-error *ngIf="email.get('email')?.invalid">E-mail inválido.</mat-error>
      </mat-form-field>

      <!-- <div class="mb-16">
        <mat-radio-button [checked]="email.get('isPrimary')?.value" (change)="onEmailPrimaryChange(i)">
          <b>Email principal</b>
        </mat-radio-button>
      </div> -->
    </div>
  </form>
</mat-dialog-content>

<mat-dialog-actions class="d-flex gap-2">
  <button
    *ngIf="isEditMode"
    mat-icon-button
    [disabled]="desabilitarApagar"
    class="me-auto color-brand-principal"
    (click)="onDelete()"
    matTooltip="Excluir"
    matTooltipPosition="above"
  >
    <mat-icon svgIcon="lixo-current"></mat-icon>
  </button>
  <button mat-button (click)="onCancel()">Cancelar</button>
  <button mat-flat-button [disabled]="!contactDataForm.valid" (click)="onSave()">Salvar</button>
</mat-dialog-actions>
